// extracted by mini-css-extract-plugin
export default {"chart-container":"DoughnutChart_chart-container__Uu05S","chart-no-data":"DoughnutChart_chart-no-data__wsex1","external-tooltip":"DoughnutChart_external-tooltip__3LPZW"};